
//IMAGE-mainPage-container-image.jpg
export const ContainerImage=({pathName,inlineImgStyle,inlineStyle})=>{
    return(
        <div className='__container'>
            <div  style={inlineStyle?{inlineStyle}:{}} className='container-image'>
                <img style={inlineImgStyle?{inlineImgStyle}:{}} src={require(`../../../../static/${pathName}`)}/>
            </div>
        </div>
    )
}